import { useTranslation } from "../i18n";
import PalletsAdmin from "../components/PalletsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin › Warehouse › Pallets Created — every sale pallet label printed
// from Goods In › Pallets, one table per warehouse. Mirrors admin-inbound.tsx.
const AdminPalletsPage = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide admin-pallets-page" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="pallets_admin_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "pallets_admin_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("pallets_admin_hint")}</p>
                <PalletsAdmin />
            </div>
        </div>
    );
};

export default AdminPalletsPage;
